
import { useState } from 'react';

export default function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gray-400 mb-4">
              © 2025 Cambridge JBS Alumni Türkiye Society. All rights reserved.
            </p>
            <div className="flex justify-center space-x-6 text-sm">
              <button
                onClick={() => setShowPrivacy(true)}
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Privacy
              </button>
              <button
                onClick={() => setShowTerms(true)}
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Terms
              </button>
            </div>
          </div>
        </div>
      </footer>

      {showPrivacy && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl max-h-96 overflow-y-auto p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-900">Privacy Notice</h3>
              <button
                onClick={() => setShowPrivacy(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="text-gray-700 space-y-4">
              <p>
                Cambridge JBS Alumni Türkiye Society (“we”, “our”, “the Society”)
              </p>
              <p>
                We are committed to protecting your personal data and respecting your privacy. This Policy explains how we collect, use, store, and share your information in line with:
              </p>
              <p>
                UK General Data Protection Regulation (UK GDPR)
              </p>
              <p>
                UK Data Protection Act 2018
              </p>
              <p>
                The Cambridge JBS Alumni Türkiye Society is an official alumni group recognised by Cambridge Judge Business School (CJBS) Alumni Relations and operating within the wider University of Cambridge alumni community. The Society is a separate organisation from CJBS and the University. Each may act as an independent controller for the data they process.
              </p>
              <p>
                2. What Information We Collect
              </p>
              <p>
                We may collect and process:
              </p>
              <p>
                Identification and contact details: name, email address, phone number, postal address
              </p>
              <p>
We do not intentionally collect special category data unless you voluntarily provide it for a defined purpose (for example, accessibility needs for an event).
              </p>
              <p>
                3. Legal Bases for Processing
              </p>
              <p>
                Under UK GDPR and the Data Protection Act 2018
              </p>
              <p>
                Consent: when you opt in to communications or provide information for stated purposes
              </p>
              <p>
                Legitimate interests: alumni engagement, Society administration, event communications
              </p>
              <p>
                Legal obligation: where we must comply with applicable law
              </p>
              <p>
                Under KVKK (Law No. 6698)
              </p>
              <p>
                Explicit consent: for communications, profiling for alumni engagement, use of submitted content
              </p>
              <p>
                Legal obligations: where processing is required by law
              </p>
              <p>
                Contract performance: for services such as event registration and participation
              </p> 
              <p>
                Where required, we obtain explicit consent under both frameworks.
              </p>
              <p>
                4. How We Use Your Information
              </p>
              <p>
                We use personal data to:
              </p>
              <p>
                Build and maintain an engaged CJBS alumni network in Türkiye
              </p>
              <p>
                Administer events and related logistics
              </p>
              <p>
                Recognise alumni achievements and publish submissions, with consent where required
              </p>
              <p>
                5. Data Sharing and International Transfers
              </p>
              <p>
We may share personal data with:
              </p>
              <p>
                CJBS and the University of Cambridge alumni teams to coordinate alumni engagement
              </p>
              <p>
                Event partners/venues when necessary for logistics and access control
              </p>
              <p>
                Technology and service providers that support our website, mailings, or registration tools, under appropriate confidentiality and data processing terms
              </p>
              <p>
                We do not sell or rent personal data.
              </p>
              <p>
                Transfers between Türkiye and the UK may occur. We apply safeguards required by UK GDPR and KVKK, such as contractual protections and, where needed, obtaining explicit consent.
              </p>
              <p>
                6. Data Retention
              </p>
              <p>
We retain personal data only as long as necessary for the purposes described above or as required by law. You may request deletion, subject to legal and record-keeping obligations.
              </p>
              <p>
7. Your Rights
              </p>
              <p>
                Your rights depend on the applicable law and your location.
              </p>
              <p>
                Under UK GDPR, you may:
              </p>
              <p>
                Request access to your data
              </p>
              <p>
Request rectification of inaccurate data
                </p>
              <p>
                Request erasure in defined circumstances
              </p>
              <p>
                Request restriction or object to processing
              </p>
              <p>
Withdraw consent at any time, where consent is the basis
              </p>
              <p>        
                Under KVKK (Article 11), you may:
              </p>
              <p>
                Learn whether your data is processed and request related information
              </p>
              <p>
                Learn the purpose of processing and whether it is used accordingly
              </p>
              <p>
                Know third parties to whom data is transferred
              </p>
              <p>
                Request correction or deletion of data in the conditions set by law
              </p>
              <p>
                Request notification of such actions to third parties
              </p>
              <p>
                Object to adverse outcomes arising from exclusively automated processing
              </p>
              <p>
                Seek compensation for damages arising from unlawful processing
              </p>
              <p>
                To exercise rights, contact: info@cambridgealumni.org.tr
              </p>
              <p></p>
              <p>
                8. Cookies and Analytics
              </p>
              <p>
                Our website may use cookies to improve user experience and analyse traffic. You can manage cookie settings in your browser. We do not identify you through cookies unless you provide information explicitly (for example, through a form).
              </p>
              <p>
                9. Updates to This Policy
              </p>

              <p>
                We may update this Policy from time to time. Changes will appear on this page with an updated effective date. Continued use of the site indicates acceptance of the updated Policy.
              </p>
              <p>
                10. Contact
              </p>
              <p>
                For questions or data protection enquiries, please contact: info@cambridgealumni.org.tr
              </p>
              <p>
                Cambridge JBS Alumni Türkiye Society, Türkiye
              </p>
             
            </div>
          </div>
        </div>
      )}

      {showTerms && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl max-h-96 overflow-y-auto p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-900">Terms of Use</h3>
              <button
                onClick={() => setShowTerms(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="text-gray-700 space-y-4">
            <p>
                Cambridge JBS Alumni Türkiye Society (“we”, “our”, “the Society”)
              </p>
              <p>
                By accessing or using this website, you agree to the terms below. If you do not agree, please refrain from using the site.
              </p>
              <p>
                1. Official Status
              </p>
              <p>
                The Cambridge JBS Alumni Türkiye Society is an official alumni group recognised by University of Cambridge and Cambridge Judge Business School (CJBS) Alumni Relations and operates within the wider University of Cambridge alumni community. The policies and guidelines of CJBS and the University of Cambridge apply alongside the terms set out here. Where there is overlap, the University/CJBS terms prevail.
              </p>
              <p>
                2. Purpose of the Website
              </p>
              <p>
                This website exists to inform, connect, and engage Cambridge Judge Business School alumni based in or connected to Türkiye, and others with academic, professional, cultural, or personal links to the country. It provides updates on events, initiatives, news, and ways to participate in Society activities.
              </p>
              <p>
                You agree to use the site lawfully and in line with the Society’s objectives. You must not:
              </p>
              <p>
                Use the site for any fraudulent, unlawful, or harmful purpose;
              </p>
              <p>
                Impersonate any person or entity, including CJBS, the University, or other alumni;
              </p>
              <p>
                Upload or transmit content that is defamatory, offensive, or infringes intellectual property rights;
              </p>
              <p>
                When submitting information or registering, you agree to provide accurate and current data.
              </p>
              <p>
                Personal data will be processed in accordance with UK GDPR, the University of Cambridge/CJBS data protection policies, and Türkiye’s Personal Data Protection Law No. 6698 (KVKK). By submitting your information, you consent to its use for alumni engagement and communications related to the Cambridge JBS Alumni Türkiye Society.
              </p>
              <p>
                5. Intellectual Property
              </p>
              <p>
Unless stated otherwise, all site content (text, design, images, logos) is the intellectual property of the Society or used under licence. Content may not be copied, reproduced, modified, distributed, or used commercially without prior written permission.
                “University of Cambridge,” “Cambridge Judge Business School,” and related names/shields are trademarks of the University of Cambridge and are used with respect; no licence is granted by this site.
              </p>
              <p>
                6. Events and Programmes
              </p>
              <p>
                Participation in events or initiatives promoted here may be subject to additional terms, including registration procedures, eligibility, fees, and attendance policies. The Society may modify, postpone, or cancel events at its discretion.
              </p>
              <p>
                7. Alumni News and Submissions
              </p>
              <p>
                Alumni may submit updates for potential publication. By submitting content, you grant the Society a non-exclusive, royalty-free licence to publish, edit, or remove the content as appropriate. The Society retains editorial discretion over all published material.
              </p>
              <p>
                8. Third-Party Content and Links
              </p>
              <p>
                The site may link to external websites or include third-party content for convenience. The Society is not responsible for the accuracy, reliability, or security of third-party content and such links do not imply endorsement.
              </p>
              <p>
                9. Limitation of Liability
              </p>
              <p>
                While we aim for accuracy and reliability, the Society makes no warranties regarding completeness or fitness for a particular purpose. The Society shall not be liable for any direct or indirect loss or damage arising from use of, or inability to use, the website or its content.
              </p>
              <p>
                10. Changes to Terms
              </p>
              <p>
                We may update these Terms and Conditions at any time. Changes will be posted on this page with an updated effective date. Continued use of the site constitutes acceptance of the revised terms.
              </p>
             
              <p>
                11. Contact Us
              </p>
              <p>
                For questions about these Terms and Conditions or the Cambridge JBS Alumni Türkiye Society, please contact:
              </p>
              <p>
                info@cambridgealumni.org.tr
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
